module.exports = __webpack_public_path__ + "img/outtake_1.cefc86bc.jpeg";